<p-table
  #dt
  [value]="parts"
  [(selection)]="selectedParts"
  dataKey="id"
  [rowHover]="true"
  [loading]="false"
  [paginator]="false"
  currentPageReportTemplate="Zeige {first} bis {last} von {totalRecords} Einträgen"
  [filterDelay]="0"
  [globalFilterFields]="['zeichindex', 'artnr', 'numberOfReports', 'anzahl']"
  dataKey="artnr"
  [scrollable]="true"
  scrollHeight="70vh"
  sortField="artnr"
  [sortOrder]="-1"
  class="overflow w-full"
  (onRowSelect)="onRowSelect($event)"
  (onRowUnselect)="onRowUnselect($event)"
  (onHeaderCheckboxToggle)="onHeaderCheckboxToggle($event)"
>
  >
  <ng-template pTemplate="header">
    <tr>
      <th style="min-width: 3%" class="justify-center">
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
      </th>
      <th style="min-width: 28%">{{ "report.images" | translate }}</th>
      <th style="min-width: 23%" [pSortableColumn]="'artnr'">
        {{ "dashboard.spec" | translate }}
        <p-sortIcon [field]="'analysisNo'"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="artnr"
          display="menu"
          [showOperator]="false"
          [showAddButton]="false"
          showMatchModes="true"
          matchMode="contains"
          showClearButton="true"
          showApplyButton="true"
          showMenu="true"
        >
        </p-columnFilter>
      </th>
      <th style="min-width: 23%" [pSortableColumn]="'zeichindex'">
        {{ "partlist.partNo" | translate }}
        <p-sortIcon [field]="'dateOfAnalysis'"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="zeichindex"
          display="menu"
          [showOperator]="false"
          [showAddButton]="false"
          showMatchModes="true"
          matchMode="contains"
          showClearButton="true"
          showApplyButton="true"
          showMenu="true"
        >
        </p-columnFilter>
      </th>
      <th style="min-width: 23%" [pSortableColumn]="'anzahl'">
        {{ "partlist.numberOfReports" | translate }}
        <p-sortIcon [field]="'dateOfAnalysis'"></p-sortIcon>
        <p-columnFilter
          field="anzahl"
          type="numeric"
          display="menu"
          [showOperator]="false"
          [showAddButton]="false"
          showMatchModes="true"
          showClearButton="true"
          showApplyButton="true"
          showMenu="true"
        >
        </p-columnFilter>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-index="rowIndex">
    <tr>
      <td class="justify-center" style="min-width: 3%">
        <p-tableCheckbox [value]="rowData" [index]="index"></p-tableCheckbox>
      </td>
      <td style="min-width: 28%">
        <img
          [src]="rowData.imgurl"
          style="height: 100px"
          class="bg-white"
          onerror="this.src='images/no_image.svg'"
        />
      </td>
      <td style="min-width: 23%">
        {{ rowData.artnr }}
      </td>
      <td style="min-width: 23%">
        {{ rowData.zeichindex }}
      </td>
      <td style="min-width: 23%">
        {{ rowData.anzahl }}
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="8" style="text-align: left">No parts found.</td>
    </tr>
  </ng-template>
</p-table>
